export const OIDC_CONFIG = {
	authority: import.meta.env.VITE_OIDC_AUTHORITY,
	client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
	scope: 'openid profile email app offline_access roles',
	redirect_uri: import.meta.env.VITE_OIDC_REDIRECT_URI,
	silent_redirect_uri: import.meta.env.VITE_OIDC_REDIRECT_URI,
};
